import { pharmacyClient } from "@/connect";

export const getPurchaseOrders = async (page: number, pageSize: number) => {
  const response = await pharmacyClient.listPurchaseOrders({
    pageNumber: page,
    pageSize: pageSize,
    includeUsed: true,
  });
  
  return {
    purchaseOrders: response.purchaseOrders,
    totalCount: response.totalCount,
  };
};